import React from 'react';
import PropTypes from 'prop-types';
import { Navbar, NavbarBrand } from 'shards-react';
import { Dispatcher, Constants } from '../../../flux';
import './style.css';

import { getFile } from '@opu/utils';
const Logo = ({ role, idEstablishment }) => {
  if (role === 'ESTABLISHMENT_USER') {
    return <img src={getFile('logo', idEstablishment)} alt="opu" className="logo-image-establishment-user" />;
  } else {
    return (
      <span className="d-none d-md-inline ml-1 dashboard-logo-container">
        <img src="/assets/images/logo.png" alt="opu" className="dashboard-logo-image" />
      </span>
    );
  }
};
class SidebarMainNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.handleToggleSidebar = this.handleToggleSidebar.bind(this);
  }

  handleToggleSidebar() {
    Dispatcher.dispatch({
      actionType: Constants.TOGGLE_SIDEBAR,
    });
  }

  render() {
    const { hideLogoText } = this.props;
    return (
      <div className="main-navbar">
        <Navbar className="align-items-stretch bg-white flex-md-nowrap border-bottom p-0" type="light">
          <NavbarBrand className="w-100 mr-0" style={{ lineHeight: '25px' }}>
            <div className="d-table m-auto">
              <Logo role={this.props.role} idEstablishment={this.props.idEstablishment} />
            </div>
          </NavbarBrand>
          <a className="toggle-sidebar d-sm-inline d-md-none d-lg-none" onClick={this.handleToggleSidebar}>
            <i className="material-icons">&#xE5C4;</i>
          </a>
        </Navbar>
      </div>
    );
  }
}

SidebarMainNavbar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool,
};

SidebarMainNavbar.defaultProps = {
  hideLogoText: false,
};

export default SidebarMainNavbar;
